import { useEffect, useRef, useState } from 'react';

export function useDashboardToast() {
  const [toast, setToast] = useState({ open: false, message: '', tone: 'ok' });
  const timerRef = useRef(null);

  // timeout: ms until auto-close. 0 = stay open until dismissToast()
  const triggerToast = (message, tone = 'ok', options = {}) => {
    const ms = options.timeout !== undefined ? Number(options.timeout) : 2200;
    setToast({ open: true, message, tone });
    if (timerRef.current) clearTimeout(timerRef.current);
    if (ms > 0) {
      timerRef.current = setTimeout(() => {
        setToast((t) => ({ ...t, open: false }));
      }, ms);
    }
  };

  const dismissToast = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast((t) => ({ ...t, open: false }));
  };

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  return { toast, triggerToast, dismissToast };
}

